/* eslint-disable import/prefer-default-export */
import { useQuery } from "@tanstack/react-query";

import type { ScheduledReportOptions } from "api/models";
import { getScheduledReportOptions } from "api/services/user";
import { userQueryKeys } from "../userQueryKeys";

export const useGetScheduledReportOptions = (enabled: boolean) =>
  useQuery<ScheduledReportOptions>({
    queryKey: userQueryKeys.scheduledReportOptions,
    queryFn: () => getScheduledReportOptions().then((res) => res.data),
    enabled,
  });
